<template>
  <img
    class="mask-on-video"
    src="/static/images/elements/person-mask-new.png"
  />
</template>
<script>
  export default {
    name: 'mask-on-video-default'
  };
</script>
<style lang="scss" scoped>
  .mask-on-video {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0.4;
    z-index: 2;
  }
</style>
